// Sub-pages (new/detail) belong to their list page's nav entry.
const parentRoute: Record<string, string> = {
    'shift-new':       'shifts',
    'shift-detail':    'shifts',
    'incident-new':    'incidents',
    'incident-detail': 'incidents',
}

export const navIcons: Record<string, string> = {
    'dashboard':       'i-lucide-layout-dashboard',
    'shifts':          'i-lucide-clipboard-list',
    'reports':         'i-lucide-bar-chart-3',
    'electricity':     'i-lucide-zap',
    'tickets':         'i-lucide-flag',
    'faults':          'i-lucide-alert-triangle',
    'incidents':       'i-lucide-wrench',
    'personnel':       'i-lucide-users',
    'reference':       'i-lucide-list',
    'schedule':        'i-lucide-calendar-clock',
    'field-bounds':    'i-lucide-shield-alert',
    'users':           'i-lucide-user-cog',
}

export const navRouteName = (name: string | symbol | null | undefined): string | undefined => {
    if (typeof name !== 'string') return undefined

    return parentRoute[name] ?? name
}
